'use strict';

var app = angular.module('limaApp');

app.config(['$stateProvider',
function ($stateProvider) {
  $stateProvider
  .state('system', {
    url: '/system',
    templateUrl: 'app/system/system.html',
    controller: 'SystemCtrl',
    authenticate: true,
    functionName: 'SystemManagement',
    title: 'System Settings'
  });
}]);
